/**
 * Navigation d'un audit projet (sidebar).
 * @param {string} slug
 * @param {Record<string, import('react').ComponentType>} icons - icônes lucide pour la sidebar
 */
export function getProjectNavigation(slug, icons = {}) {
  const base = `/projects/${slug}`;
  const items = [
    { key: 'synthese', routeKey: '', label: 'Vue d\'ensemble', path: base },
    { key: 'seo', routeKey: 'seo', label: 'SEO & contenu', path: `${base}/seo` },
    { key: 'performance', routeKey: 'performance', label: 'Performance & technique', path: `${base}/performance` },
    { key: 'position', routeKey: 'position', label: 'Visibilité IA', path: `${base}/position` },
    { key: 'reference-pages', routeKey: 'reference-pages', label: 'Pages de référence', path: `${base}/reference-pages` },
    { key: 'edit', routeKey: 'edit', label: 'Paramètres', path: `${base}/edit` },
  ];
  return items.map((item) => ({
    ...item,
    icon: icons[item.key],
  }));
}

/** Déduit la clé d'onglet active depuis le pathname. */
export function getActiveProjectNavKey(pathname, projectSlug) {
  if (!projectSlug || !pathname.startsWith(`/projects/${projectSlug}`)) return '';
  const path = pathname;
  if (path === `/projects/${projectSlug}` || path === `/projects/${projectSlug}/`) return 'synthese';
  if (path.includes('/reference-pages')) return 'reference-pages';
  if (path.includes('/seo')) return 'seo';
  if (path.includes('/internal-links')) return 'seo';
  if (path.includes('/performance')) return 'performance';
  if (path.includes('/errors')) return 'performance';
  if (path.includes('/position')) return 'position';
  if (path.includes('/visual-audit')) return 'position';
  if (path.includes('/edit')) return 'edit';
  return 'synthese';
}
